import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Pane, Card } from '@costar/theme-ui';
import { FodalBase } from './fodal-base.esm.js';

var FodalCardBase = function FodalCardBase(_ref) {
  var modalProps = _ref.modalProps,
    paneProps = _ref.paneProps,
    cardProps = _ref.cardProps,
    cardHeaderProps = _ref.cardHeaderProps,
    cardHeader = _ref.cardHeader,
    cardContentProps = _ref.cardContentProps,
    cardContent = _ref.cardContent,
    cardFooterProps = _ref.cardFooterProps,
    cardFooter = _ref.cardFooter;
  return /*#__PURE__*/React.createElement(FodalBase, modalProps, /*#__PURE__*/React.createElement(Pane, _extends({
    variant: "fodal.pane"
  }, paneProps), /*#__PURE__*/React.createElement(Card.Card, _extends({
    useContext: true,
    variant: "fodal.card"
  }, cardProps), cardHeader && /*#__PURE__*/React.createElement(Card.Header, cardHeaderProps, cardHeader), cardContent && /*#__PURE__*/React.createElement(Card.Content, cardContentProps, cardContent), cardFooter && /*#__PURE__*/React.createElement(Card.Footer, cardFooterProps, cardFooter))));
};

export { FodalCardBase };
//# sourceMappingURL=fodal-card-base.esm.js.map
